// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { Flex } from '@teamnine/pcj-ui-v2'
import styled from 'styled-components'

export const Wrapper = styled(Flex)`
  height: 100%;
`
